/**
 * BYOB Bundle Builder - GA4 Tracking Integration (Clean Version)
 * Tracks all 5 bundle builder events for Pigeon Baby
 * NO CONSOLE LOGS - Production Ready
 */

(function() {
  'use strict';

  // Check if we're on a bundle page
  const isBundlePage = window.location.pathname.includes('bundle') || 
                       document.querySelector('[data-byob-bundle]') ||
                       document.querySelector('.byob-bundle-builder') ||
                       document.querySelector('[id*="byob"]') ||
                       document.querySelector('[class*="byob"]');

  if (!isBundlePage) return;

  // Helper function to track events
  function trackBundleEvent(eventName, params = {}) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    } else if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        'event': eventName,
        ...params
      });
    }
  }

  // Get bundle information
  function getBundleInfo() {
    const bundleTitle = document.querySelector('[data-byob-title]')?.textContent ||
                       document.querySelector('h1')?.textContent ||
                       'Unknown Bundle';
    
    return {
      bundle_name: bundleTitle.trim(),
      page_location: window.location.href,
      page_path: window.location.pathname
    };
  }

  // Track bundle start (page load)
  let bundleStartTracked = false;
  function trackBundleStart() {
    if (bundleStartTracked) return;
    bundleStartTracked = true;
    
    trackBundleEvent('bundle_builder_start', {
      ...getBundleInfo(),
      timestamp: new Date().toISOString()
    });
  }

  // Track when page is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackBundleStart);
  } else {
    trackBundleStart();
  }

  // Track bundle item additions
  let itemsAdded = 0;
  function trackAddItem(productElement) {
    itemsAdded++;
    
    const productName = productElement.closest('.byob-product, [data-byob-product], .product-item')
                                     ?.querySelector('.product-title, .product-name, h3, h4')
                                     ?.textContent?.trim() || 'Unknown Product';
    
    const productPrice = productElement.closest('.byob-product, [data-byob-product], .product-item')
                                      ?.querySelector('.price, [class*="price"]')
                                      ?.textContent?.trim() || '';

    trackBundleEvent('bundle_builder_add_item', {
      ...getBundleInfo(),
      item_name: productName,
      item_price: productPrice,
      items_in_bundle: itemsAdded,
      timestamp: new Date().toISOString()
    });
  }

  // Listen for "Add To Bundle" button clicks
  document.addEventListener('click', function(e) {
    const addButton = e.target.closest('[data-byob-add], .byob-add-button, button[class*="add-to-bundle"], button:contains("Add To Bundle")');
    
    if (addButton && addButton.textContent.toLowerCase().includes('add')) {
      trackAddItem(addButton);
    }
  }, true);

  // Track category/step changes
  let currentStep = 1;
  let stepObserver = null;

  function trackStepChange(stepNumber, stepName) {
    trackBundleEvent('bundle_builder_step', {
      ...getBundleInfo(),
      step_number: stepNumber,
      step_name: stepName,
      timestamp: new Date().toISOString()
    });
  }

  // Observe for category tab clicks
  function setupStepTracking() {
    const categoryButtons = document.querySelectorAll('[data-byob-category], [class*="category-tab"], [class*="step-tab"], button[class*="tab"]');
    
    categoryButtons.forEach((button, index) => {
      button.addEventListener('click', function() {
        const stepName = button.textContent.trim() || `Step ${index + 1}`;
        trackStepChange(index + 1, stepName);
      });
    });

    const accordionSections = document.querySelectorAll('[data-byob-section], .byob-section, [class*="accordion"]');
    accordionSections.forEach((section, index) => {
      section.addEventListener('click', function(e) {
        if (e.target.tagName === 'BUTTON' || e.target.closest('button')) {
          const sectionName = section.querySelector('h1, h2, h3, h4, h5')?.textContent.trim() || `Section ${index + 1}`;
          trackStepChange(index + 1, sectionName);
        }
      });
    });
  }

  setTimeout(setupStepTracking, 1000);

  // Track bundle completion (add to cart)
  let bundleCompleted = false;
  function trackBundleComplete() {
    if (bundleCompleted) return;
    bundleCompleted = true;

    trackBundleEvent('bundle_builder_complete', {
      ...getBundleInfo(),
      items_in_bundle: itemsAdded,
      timestamp: new Date().toISOString()
    });
  }

  // Listen for BYOB add to cart completion
  document.addEventListener('click', function(e) {
    const cartButton = e.target.closest('[data-byob-cart], [class*="add-bundle-to-cart"], button[class*="bundle-cart"], button:contains("Add Bundle To Cart")');
    
    if (cartButton) {
      trackBundleComplete();

      setTimeout(() => {
        const successMessage = document.querySelector('.byob-success, [class*="success"]');
        if (successMessage) {
          // Bundle successfully added
        }
      }, 1000);
    }
  }, true);

  // Listen for Shopify cart events
  if (typeof Shopify !== 'undefined' && Shopify.analytics) {
    document.addEventListener('product_added_to_cart', function() {
      if (isBundlePage && itemsAdded > 0) {
        trackBundleComplete();
      }
    });
  }

  // Track bundle dropoff
  let dropoffTracked = false;
  function trackBundleDropoff() {
    if (dropoffTracked || bundleCompleted) return;
    dropoffTracked = true;

    if (itemsAdded > 0) {
      trackBundleEvent('bundle_builder_dropoff', {
        ...getBundleInfo(),
        items_in_bundle: itemsAdded,
        dropoff_reason: 'page_exit',
        timestamp: new Date().toISOString()
      });
    }
  }

  window.addEventListener('beforeunload', trackBundleDropoff);
  window.addEventListener('pagehide', trackBundleDropoff);

  let userLeftPage = false;
  document.addEventListener('visibilitychange', function() {
    if (document.hidden && !bundleCompleted && itemsAdded > 0 && !userLeftPage) {
      userLeftPage = true;
      setTimeout(() => {
        if (document.hidden && !bundleCompleted) {
          trackBundleDropoff();
        }
      }, 5000);
    }
  });

  // Observe for BYOB app changes
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          setupStepTracking();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

})();